import { mappers } from './utils';
import {
  IValidateVisibleViolationsFail,
  IValidateVisibleViolationsParams,
  IValidateVisibleViolationsSuccess,
  TValidateVisibleViolationsResult,
} from './types';
import { THeaders } from '../../types/request';
import { fetchValidateVisibleViolations } from '../../repositories/monolith-python/v2/validate-visible-violations';
import { DEFAULT_RESPONSE } from './constants';

export async function validateVisibleViolations(
  params: IValidateVisibleViolationsParams,
): Promise<TValidateVisibleViolationsResult> {
  const { httpApi, parameters, subdomain, skipHash } = params;

  const headers: THeaders = [[ 'Content-Type', 'application/json' ]];

  if (skipHash) {
    headers.push([ 'VisibleViolations-Skip', skipHash ]);
  }

  const requestConfig = {
    headers,
  };

  try {
    const response = await fetchValidateVisibleViolations<
      IValidateVisibleViolationsSuccess,
      IValidateVisibleViolationsFail
    >({
      httpApi,
      parameters,
      config: { requestConfig, subdomain },
      mappers,
    });

    return response as TValidateVisibleViolationsResult;
  } catch (error) {
    return DEFAULT_RESPONSE;
  }
}
